import {SuperBit_swaggerClient,FilterDataModel,ActionType, RiderModel,RiderGetPaymentPage2Request, PaymentModel} from './superbit-api-models'
import generalSettings from '../json/general-settings.json';

export class SubscribersModel
{
    client:any;
    constructor() {
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt.superbit.co.il");
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }
    
    async getAllRiders(){
        return this.client.riderIndex(new FilterDataModel());
    }

    async getAllRidersByFilter(filter: FilterDataModel){
        return this.client.riderFilter(filter);
    }

    async upsertRider(data: any){
        return this.client.riderCreateRiderSubscriber2(data);
    }

    async saveNewRider(data: any){
        
        return this.client.riderCreateRider(data);
    }

    async riderUpdateDetails(data: any){
        return this.client.riderUpdateDetails(data);
    }
    async RiderFixEndDate(data: any){
        return this.client.RiderFixEndDate(data);
    }

    
    async RiderCheckActiveVehicle(data: string){
        return this.client.RiderCheckActiveVehicle(data);
    }
    

    async riderGetPackages(data: any){
        
        return this.client.riderGetPackages(data);
    }

    async riderGetPaymentPage(rider:RiderModel){
        return this.client.riderGetPaymentPage(rider);
    }

    async riderGetPaymentPage2(riderId:string|undefined,paymentId:string|undefined){
        return this.client.riderGetPaymentPage2(new RiderGetPaymentPage2Request({
            RiderId: riderId,
            PaymentId: paymentId
        }));
    }

    async riderGetPayments(riderId:string|undefined,paymentId:string|undefined){
        return this.client.riderGetPayments(new RiderGetPaymentPage2Request({
            RiderId: riderId,
            PaymentId: paymentId
        }));
    }

    getPaymentMethodType(){
        return this.client.getAppDictionaryList("PaymentMethodType");
    }

    getPaymentStatuses(){
        return this.client.getAppDictionaryList("PaymentStatus");
    }

    paymentUpdatePayment(model:PaymentModel){
        return this.client.paymentUpdatePayment(model);
    }
    
    // async riderUpdateDetails(data: any){
    //     return this.client.riderUpdateDetails(data);
    // }

    async riderChangePackages(data: any){
        return this.client.riderChangePackages(data);
    }
    async riderChangeVehicle(data: any){
        return this.client.riderChangeVehicle(data);
    }

    async riderGenerateServiceReporter(id: string|undefined){
        return this.client.riderGenerateServiceReporter(id);
    }

    riderRenewRiderSubscriber(id: any){
        return this.client.riderRenewRiderSubscriber(id);
    }

    paymentUpdateAmount(payment:PaymentModel){
        return this.client.paymentUpdateAmount(payment);
    }

    riderActivateRider(riderId:string){
        return this.client.riderActivateRider(riderId);
    }
}





